/**
 * Derives the y axis bounds and tick spacing of a heart-rate chart from the observed extremes. Rounds the minimum down to the previous ten and a further ten when it is already a multiple of ten, rounds the maximum up two tens and once more unless the result divides by four, and falls back to a 0 to 120 axis with a 40 tick when there is no data.
 *
 * @param minData - Lowest heart rate in the series.
 * @param maxData - Highest heart rate in the series, zero when there is no data.
 * @returns An object carrying min, max and tickInterval for the axis.
 */
export const getMinMaxChart = (minData: number, maxData: number) => {
  // pre-existing: parseInt expects a string; a number is passed here and coerces fine at runtime.
  const min =
    minData === 0
      ? 0
      : minData % 10 === 0
        ? (parseInt((minData / 10) as any, 10) - 1) * 10
        : parseInt((minData / 10) as any, 10) * 10;
  const tMax = (parseInt((maxData / 10) as any, 10) + 2) * 10;
  const max = maxData === 0 ? 120 : tMax % 4 === 0 ? tMax : tMax + 10;
  const tickInterval = maxData === 0 ? 40 : max / 4;
  return { min, max, tickInterval };
};

/**
 * Checks that a loaded ECG data map actually carries minutely heart-rate samples. Scans every entry and flags the map valid as soon as one holds a non-empty avgHrs array.
 *
 * @param data - The hourly summary entries to inspect.
 * @returns True when at least one entry has average heart-rate samples.
 */
export const validateEcgDataMap = (data: any[]) => {
  let isValidData = false;
  data.forEach((item) => {
    if (item?.avgHrs?.length > 0) {
      isValidData = true;
    }
  });
  return isValidData;
};
